import React from "react";
import {
  ContentsBoxStyle,
  IconStyle,
  LabelStyle,
  ValueStyle,
  WrapStyle,
} from "./styles";

interface DashboardStatsticProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  icon: React.ReactNode;
  iconBgColor?: string;
}

const DashboardStastic = ({
  label,
  icon,
  iconBgColor,
  children,
  ...rest
}: DashboardStatsticProps) => {
  return (
    <WrapStyle {...rest}>
      <IconStyle iconBgColor={iconBgColor}>{icon}</IconStyle>
      <ContentsBoxStyle>
        <LabelStyle>{label}</LabelStyle>
        <ValueStyle>{children}</ValueStyle>
      </ContentsBoxStyle>
    </WrapStyle>
  );
};

export default DashboardStastic;
